import { useState, useEffect } from 'react';
import { useProfile } from '@/hooks/useProfile';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, DollarSign } from 'lucide-react';

export function CurrencySettings() {
  const { profile, isLoading, updateProfile } = useProfile();
  const [currency, setCurrency] = useState<'CRC' | 'USD'>('CRC');

  useEffect(() => {
    if (profile?.default_currency) {
      setCurrency(profile.default_currency);
    }
  }, [profile?.default_currency]);

  const handleSave = () => {
    updateProfile.mutate({ default_currency: currency });
  };

  if (isLoading) {
    return <div className="text-muted-foreground">Cargando...</div>;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="h-5 w-5" />
          Configuración de Moneda
        </CardTitle>
        <CardDescription>
          Selecciona la moneda predeterminada para nuevas transacciones
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="default-currency">Moneda Predeterminada</Label>
          <Select value={currency} onValueChange={(val) => setCurrency(val as 'CRC' | 'USD')}>
            <SelectTrigger id="default-currency" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="CRC">
                <div className="flex items-center gap-2">
                  <span>₡</span>
                  <span>Colones (CRC)</span>
                </div>
              </SelectItem>
              <SelectItem value="USD">
                <div className="flex items-center gap-2">
                  <DollarSign className="h-4 w-4" />
                  <span>Dólares (USD)</span>
                </div>
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button 
          onClick={handleSave} 
          disabled={updateProfile.isPending || currency === profile?.default_currency}
        >
          {updateProfile.isPending ? 'Guardando...' : 'Guardar'}
        </Button>
      </CardContent>
    </Card>
  );
}
